import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {Sort, MatSortModule} from '@angular/material/sort';
import {PatientService} from '../../Services/patient.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Subject} from "rxjs";

interface QuestionItem {
    section: string;
    question: string;
    type: string;
    options?: string[];
}

@Component({
    selector: 'pm-client-registration',
    templateUrl: './client-registration.component.html',
    styleUrls: ['./client-registration.component.css']
})
export class ClientRegistrationComponent implements OnInit {

    tableData: any = [];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    fileImage: string | null = null; // Variable to hold the image URL
    files: File[] = [];
    isDragOver: boolean = false;
    errorMessages: any;
    errorMessagePart:any;
    searchText: any;
    @ViewChild('fileDropRef') fileDropRef!: ElementRef;
    @ViewChild('templateUpload') templateUploadModal!: ElementRef;
    clientId:any;
    private clientSub: any;
    private subject: Subject<string> = new Subject();

/*    parsedQuestions: QuestionItem[] = [];
    formSubmitted = false;
    formResponses: any = {};
    parsedData: any[] = [];
    form: FormGroup = this.fb.group({ rows: this.fb.array([]) });*/


    spreadsheetForm: FormGroup;

    constructor(private fb: FormBuilder,
                private clientServices: ClientService,
                public authService: AuthService,
                private router : Router,
                private renderer: Renderer2,
                private patientService: PatientService,
                private http: HttpClient,
                private cdr: ChangeDetectorRef,
                private ngZone: NgZone) {
    }

    ngOnInit(): void {
        /*this.spreadsheetForm = this.fb.group({
            rows: this.fb.array([])
        });
        this.addRow();*/

        this._fetchData(1);
        this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
          if (clientId) {
            this._fetchData(1);
          }
        });
    }

    ngOnDestroy(): void {
      this.clientSub?.unsubscribe();
    }

    // Get Client data
  _fetchData(type: any) {
    let params: { [key: string]: any } = {};

    if (type === 2) {
      params.active = true;
    } else if (type === 3) {
      params.active = false;
    }

    this.clientServices.getAllClients(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response && response.length > 0) {
            this.tableData = response;

            setTimeout(() => {
              this.cdr.detectChanges();
            }, 0);
          } else {
            this.tableData = [];
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableData = [];
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || '',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
  }

      // Search
    onKeyUp(searchTextValue: any): void {
      this.subject.next(searchTextValue);
    }

    handleKeyUp(event: KeyboardEvent) {
      const value = (event.target as HTMLInputElement).value;

      // Trigger search on Enter
      if (event.key === 'Enter') {
        this.onKeyUp(this.searchText);
        return;
      }

      // Existing debounce logic
      this.subject.next(value);
    }
    clearSearch(input: HTMLInputElement) {
      input.value = '';
      this._fetchData(1);
    }

    // Method to open the modal and add background blur
    openModal(clientId:any) {
        this.clientId= clientId
        const modalElement = this.templateUploadModal.nativeElement;
        modalElement.style.display = 'flex'; // Center modal with flexbox
        modalElement.classList.add('show'); // Add the 'show' class for animation

        // Add blur to the background
        this.renderer.addClass(document.body, 'blur-background');
    }

    // Method to close the modal and remove background blur
    closeModal() {
        this.errorMessages = null
        this.errorMessagePart = null
        this.files = null;       // Optionally clear the file data as well
        this.fileImage = null;
        const modalElement = this.templateUploadModal.nativeElement;
        modalElement.style.display = 'none'; // Hide modal
        modalElement.classList.remove('show'); // Remove 'show' class

        // Remove blur from the background
        this.renderer.removeClass(document.body, 'blur-background');
    }

    upload() {
        // Your upload logic here
        // console.log('Uploading...');
    }

    onFilesSelected(event: any): void {
        const selectedFiles = event.target.files;
        this.files = Array.from(selectedFiles);

        // Check if the first selected file is an Excel file
        if (this.files.length > 0) {
            const file = this.files[0];
            if (file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'text/csv' ||
                file.type === 'application/csv') {
                // Set the image for Excel files
                this.fileImage = 'assets/img/xlxs.png'; // Path to the image for Excel files
            } else {
                this.fileImage = null; // Reset if not an Excel file
            }
        }
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }

    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
        const droppedFiles = event.dataTransfer?.files;
        if (droppedFiles) {
            this.files = Array.from(droppedFiles);
            this.fileDropRef.nativeElement.files = droppedFiles; // Set files in the input

            // Check if the dropped file is an Excel file
            const file = this.files[0];
            if (file && (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                this.fileImage = 'assets/img/xlxs.png'; // Path to the image for Excel files
            } else {
                this.fileImage = null; // Reset if not an Excel file
            }
        }
    }

    uploadFiles(): void {
        if (this.files.length) {
            const params = {
                clientId : this.clientId
            }
            const formData = new FormData();
            for (let file of this.files) {
                formData.append('file', file, file.name);
            }
            this.clientServices.clientTemplateUpload(formData,params).pipe(first()).subscribe(
                (response: any) => {
                    if (response) {
                        this._fetchData(1)
                        this.closeModal()
                        swal.fire({
                            icon: 'success',
                            text: 'Uploaded successfully.',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        this.handleErrorResponse(response);
                    }
                },
                (error) => {
                    this.handleErrorResponse(error.error);
                }
            );
            this.http.post('/api/upload-template', formData).pipe(first()).subscribe(
                (response: any) => {
                    // console.log('Mock API Response:', response);
                    if (response && response.status === 200) {
                        this.closeModal();
                        swal.fire({
                            icon: 'success',
                            text: response.message || 'Uploaded successfully.',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        this.handleErrorResponse(response);
                    }
                },
                (error) => {
                    this.handleErrorResponse(error.error);
                }
            );

        }
    }

    /*exportViewFile(format: string, clientId: string, filename: string, action: 'download' | 'view') {
        const params = {
            clientId: clientId,
            /!*format: format // Ensure format is included in the request*!/
        };

        this.clientServices.getClientTemplate(params).subscribe((response: HttpResponse<Blob>) => {
            const blob = new Blob([response.body!], {
                type: format === 'excel'
                    ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    : 'application/pdf'
            });

            const fileURL = window.URL.createObjectURL(blob);

            if (action === 'download') {
                const link = document.createElement('a');
                link.href = fileURL;
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(fileURL);
            } else {
                window.open(fileURL, '_blank');
            }
        }, (error) => {
            console.error('File download error:', error);
        });
    }*/
    /*exportViewFile(format: string, clientId: string, filename: string, action: 'download' | 'view') {
        const params = {
            clientId: clientId,
            //format: format // Ensure format is included in the request
        };

        this.clientServices.getClientTemplate(params).subscribe((response: Blob) => {
            const blob = new Blob([response], {
                type: format === 'excel'
                    ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    : 'application/pdf'
            });

            const fileURL = window.URL.createObjectURL(blob);

            if (action === 'download') {
                const link = document.createElement('a');
                link.href = fileURL;
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(fileURL);
            } else {
                window.open(fileURL, '_blank');
            }
        }, (error) => {
            console.error('File download error:', error);
        });
    }*/
    exportViewFile(clientId: string, baseFilename: string, action: 'download' | 'view') {
        const params = { clientId };

        this.clientServices.getClientTemplate(params).subscribe((response: HttpResponse<Blob>) => {
            const contentType = response.headers.get('Content-Type') || '';

            // Determine file extension from content-type
            let extension = 'pdf';
            if (contentType.includes('spreadsheetml')) {
                extension = 'xlsx';
            }

            const blob = new Blob([response.body!], { type: contentType });
            const fileURL = window.URL.createObjectURL(blob);
            const fullFilename = `${baseFilename}.${extension}`;

            // Always download
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = fullFilename;
            document.body.appendChild(link);
            link.click();
            link.remove();

            // View in browser (PDF will work, Excel may not render)
            if (action === 'view') {
                window.open(fileURL, '_blank');
            }

            // Clean up URL
            setTimeout(() => {
                window.URL.revokeObjectURL(fileURL);
            }, 100);
        }, error => {
            console.error('File export error:', error);
        });
    }

    handleErrorResponse(error: any): void {
        const errorMessage = error.message;

        if (errorMessage) {
            const { messagePart, detailsPart } = this.extractErrorDetails(errorMessage);
            this.errorMessagePart = messagePart;  // This will hold the part before "Details:"
            this.errorMessages = detailsPart;     // This will hold the parsed details as an array
        } else {
            this.errorMessagePart = 'An error occurred';
            this.errorMessages = [];
        }
    }

    extractErrorDetails(message: string): { messagePart: string, detailsPart: string[] }{
        let detailsMessage = message
        const detailsStart = message.indexOf('Details:');
        if (detailsStart === -1) {
            return { messagePart: message, detailsPart: [] };
        }

        // Extract the message part before "Details:"
        const messagePart = message.substring(0, detailsStart + 8); // +8 to include "Details:"

        /*        // Extract the details part after "Details:"
                const detailsString = message.substring(detailsStart + 8, message.length).trim();*/

        const detailsString = message.substring(detailsStart + 9, message.length - 1); // Get the details part
        const detailsArray = detailsString.match(/\[.*?\]/g); // Extract arrays from the details

        // Clean and format the error details
        const formattedErrors: string[] = [];
        if (detailsArray) {
            detailsArray.forEach((detail) => {
                formattedErrors.push(
                    detail
                        .replace(/\[|\]/g, '') // Remove square brackets
                        .split(', ') // Split by comma
                        .join(', ') // Join back the parts
                );
            });
        }

        return { messagePart, detailsPart: formattedErrors };
    }
    removeImage(): void {
        this.errorMessages = null
        this.errorMessagePart = null
        this.files = null;       // Optionally clear the file data as well
        this.fileImage = null;  // Clear the image source
    }



/*    openModal() {
        const modalElement = this.templateUploadModal.nativeElement;
        modalElement.style.display = 'flex'; // Center modal with flexbox
        modalElement.classList.add('show'); // Add the 'show' class for animation

        // Add blur to the background
        this.renderer.addClass(document.body, 'blur-background');
    }

    // Method to close the modal and remove background blur
    closeModal() {
        const modalElement = this.templateUploadModal.nativeElement;
        modalElement.style.display = 'none'; // Hide modal
        modalElement.classList.remove('show'); // Remove 'show' class

        // Remove blur from the background
        this.renderer.removeClass(document.body, 'blur-background');
    }

    // Form getters
    get rows(): FormArray {
        return this.spreadsheetForm.get('rows') as FormArray;
    }

    // Creation methods
    createRow(): FormGroup {
        return this.fb.group({
            header: [null],
            columns: this.fb.array([this.createColumn()])
        });
    }

    createColumn(): FormGroup {
        return this.fb.group({
            cells: this.fb.array([this.createCell()])
        });
    }

    createCell(): FormGroup {
        return this.fb.group({
            value: [null]
        });
    }

    // Row operations
    addRow() {
        this.rows.push(this.createRow());
    }

    removeRow(rowIndex: number) {
        this.rows.removeAt(rowIndex);
    }

    // Column operations
    getColumns(row: AbstractControl): FormArray {
        return row.get('columns') as FormArray;
    }

    addColumn(row: AbstractControl) {
        const columns = this.getColumns(row);
        columns.push(this.createColumn());
    }

    removeColumn(row: AbstractControl, columnIndex: number) {
        const columns = this.getColumns(row);
        columns.removeAt(columnIndex);
    }

    // Cell operations
    getCells(column: AbstractControl): FormArray {
        return column.get('cells') as FormArray;
    }

    addCell(column: AbstractControl) {
        const cells = this.getCells(column);
        cells.push(this.createCell());
    }

    removeCell(column: AbstractControl, cellIndex: number) {
        const cells = this.getCells(column);
        cells.removeAt(cellIndex);
    }


    // Form submission
    onSubmit() {
        if (this.spreadsheetForm.valid) {
            console.log('Form Data:', this.spreadsheetForm.value);
            // Handle form submission
            this.closeModal();
        } else {
            this.markFormGroupTouched(this.spreadsheetForm);
        }
    }

    // Utility method to mark all controls as touched
    private markFormGroupTouched(formGroup: FormGroup | FormArray) {
        Object.values(formGroup.controls).forEach(control => {
            if (control instanceof FormGroup || control instanceof FormArray) {
                this.markFormGroupTouched(control);
            } else {
                control.markAsTouched();
            }
        });
    }

    // Optional: Method to get form data as a structured object
    getFormData() {
        const formData = this.spreadsheetForm.value;
        return {
            rows: formData.rows.map((row: any) => ({
                header: row.header,
                columns: row.columns.map((column: any) => ({
                    cells: column.cells.map((cell: any) => cell.value)
                }))
            }))
        };
    }

    // Optional: Method to reset the form
    resetForm() {
        this.spreadsheetForm.reset();
        while (this.rows.length > 0) {
            this.rows.removeAt(0);
        }
        this.addRow(); // Add initial row
    }

    // Optional: Method to load existing data
    loadData(data: any) {
        this.resetForm();
        if (data && data.rows) {
            data.rows.forEach((rowData: any) => {
                const row = this.createRow();
                row.patchValue({ header: rowData.header });

                // Remove default column
                const columns = row.get('columns') as FormArray;
                columns.removeAt(0);

                // Add columns with data
                rowData.columns.forEach((columnData: any) => {
                    const column = this.createColumn();
                    const cells = column.get('cells') as FormArray;
                    cells.removeAt(0); // Remove default cell

                    // Add cells with data
                    columnData.cells.forEach((cellValue: string) => {
                        const cell = this.createCell();
                        cell.patchValue({ value: cellValue });
                        cells.push(cell);
                    });

                    columns.push(column);
                });

                this.rows.push(row);
            });
        }
    }

    // Optional: Validation methods
    isRowValid(row: AbstractControl): boolean {
        return row.valid;
    }

    isColumnValid(column: AbstractControl): boolean {
        return column.valid;
    }

    isCellValid(cell: AbstractControl): boolean {
        return cell.valid;
    }*/
    /*get rows(): FormArray {
        return this.spreadsheetForm.get('rows') as FormArray;
    }

    createRow(): FormGroup {
        return this.fb.group({
            columns: this.fb.array([this.createColumn()])
        });
    }

    createColumn(): FormGroup {
        return this.fb.group({
            cells: this.fb.array([this.createCell()])
        });
    }

    createCell(): FormGroup {
        return this.fb.group({
            value: ['', Validators.required]
        });
    }

    addRow() {
        this.rows.push(this.createRow());
    }

    removeRow(rowIndex: number) {
        this.rows.removeAt(rowIndex);
    }

    getColumns(row: AbstractControl): FormArray {
        return row.get('columns') as FormArray;
    }

    addColumn(row: AbstractControl) {
        const columns = this.getColumns(row);
        columns.push(this.createColumn());
    }

    removeColumn(row: AbstractControl, columnIndex: number) {
        const columns = this.getColumns(row);
        columns.removeAt(columnIndex);
    }

    getCells(column: AbstractControl): FormArray {
        return column.get('cells') as FormArray;
    }

    addCell(column: AbstractControl) {
        const cells = this.getCells(column);
        cells.push(this.createCell());
    }

    removeCell(column: AbstractControl, cellIndex: number) {
        const cells = this.getCells(column);
        cells.removeAt(cellIndex);
    }*/
// Delete record
/*    deleteEntry(clientId: any) {
        let reqData = {
            clientId: clientId
        };
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this record ?',
            icon: 'warning',
            iconColor: 'red',
            showCancelButton: true,
            confirmButtonText: 'Yes !'
        }).then((result) => {
            if (result.isConfirmed) {
                this.clientServices.deleteClient(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        if (response) {
                            this._fetchData();
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: 'Something went wrong!',
                                showConfirmButton: false,
                                timer: 2000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: 'Failed to communicate with the server!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    });
            }
        });
    }*/

    // Update entry
/*    updateEntry = (clientId: any) => {
        this.router.navigate(['client/details/' + clientId]).then();
    }*/

    // Sort form frontend logic
    sortData(sort: Sort) {
        const data = this.tableData.slice();
        if (!sort.active || sort.direction === '') {
            this.tableData = data;
            return;
        }

        this.tableData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name':
                    return compare(a.name, b.name, isAsc);
                case 'email':
                    return compare(a.email, b.email, isAsc);
                case 'number':
                    return compare(a.number, b.number, isAsc);
                case 'active':
                    return compare(a.active, b.active, isAsc);
                default:
                    return 0;
            }
        });
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
